import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import {
  hero,
  heroText,
  mobileHero,
  mobileHeroText,
  viewMenuButton,
  menu,
} from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView h="95vh" image={`url(${mobileHero}) center / cover no-repeat`}>
          <CFView column center w="100%" textCenter>
            <CFImage
              mt="80px"
              w="95%"
              src={mobileHeroText}
              alt="Hamaei Sushi hero text"
              zIndex={98}
            />
            <CFView pulsate mt="25px">
              <OrderPickupButton />
            </CFView>
            {/* <CFView mt="25px">
              <OrderDeliveryButton />
            </CFView> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="690px"
          w="100%"
          maxWidth="1400px"
          image={`url(${hero}) 40% 0% / cover no-repeat`}
          zIndex={90}
          column
        >
          <CFView column justifyCenter alignStart textCenter h="100%" ml="6%">
            <CFImage
              w="42%"
              maxWidth="600px"
              src={heroText}
              alt="Hamaei Sushi hero text"
              zIndex={98}
            />
            <CFView pulsate mt="30px" ml="4%">
              <OrderPickupButton />
            </CFView>
            {/* <CFView mt="25px" ml="4%">
              <OrderDeliveryButton />
            </CFView> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
